import React from 'react';

export const Privacy: React.FC = () => {
  return <h1>Политика Конфиденациальности</h1>;
};
